import React from "react";
import { showAuthor, getMultiIcon, urlDev, showUppertitle,showPreview, showTagArticle } from "../../Config/Functions/Functions";
import dynamic from "next/dynamic";
const NewsVertical03 = dynamic(() => import('../NotaBanners/NewsVertical03'));

const ZonaNews4Notas = ({data, dataFace, slug}) => {
    var count = 0;

    return (
        <>          
            {
                data ? 
                <>
            <section className="zona-4-notas desktop-inner-container">

                {/*<!-- Entry grande -->*/}
                <article className="big-entry-box">
                    <picture>
                        {
                            data[0]?.preview ?
                            <>
                                <source media="(min-width:1024px)" width={720} height={406} srcSet={urlDev+data[0].preview.sizes[0]?.url} loading="lazy"/>
                                <img src={urlDev+data[0].preview.sizes[1]?.url} width={360} height={203} alt={data[0].main?.title?.home} title={data[0].main?.title?.home} loading="lazy"/>
                            </>
                            :
                            <>
                                {showPreview(data[0].main?.title?.home, 360, 203)}
                            </>
                        }                       
                        {/*getMultiIcon(data[0].hascontent.hasgalleryvideosyoutube, data[0].gallery.length > 1, data[0].hascontent.hasaudios)*/}                       
                        {showTagArticle(data[0]?.info?.advanced?.tagarticle)}
                    </picture>
                    <div className="entry-data">
                        <h1 className="entry-title">
                            {showUppertitle(data[0]?.main?.uppertitle)}
                            {data[0]?.main?.title?.home}
                        </h1>
                        {data[0]?.main?.authors ? showAuthor(data[0].main.authors[0].fullname):null}         
                    </div>
                    <a href={data[0]?.info?.link?.url} className="cover-link" title={data[0].main?.title?.home}></a>
                </article>
                {/*<!-- Entry grande end -->*/}

                {/*<!-- 3 entrys fijos -->*/}
                <div className="three-fixed-entrys-holder has-mobile-gutter">
                        {
                            data.map((dat, index) =>{
                                if(count === 0){
                                    count++
                                    return null
                                }if(count === 1){
                                    count++
                                    return (
                                        <article className="medium-entry-box" key={index}>
                                            <picture>
                                                {
                                                    dat.preview ?
                                                    <>
                                                        <img src={urlDev+dat.preview.sizes[2]?.url} width={320} height={180} alt={dat.main?.title?.home} title={dat.main?.title?.home} loading="lazy"/>
                                                    </>
                                                    :
                                                    <>
                                                        {showPreview(dat.main?.title?.home, "320", "180")}
                                                    </>
                                                } 
                                                {/*getMultiIcon(dat.hascontent.hasgalleryvideosyoutube, dat.gallery.length > 1, dat.hascontent.hasaudios)*/}
                                                {showTagArticle(dat.info?.advanced?.tagarticle)}
                                            </picture>
                                            <div className="entry-data">
                                                <h2 className="entry-title">
                                                    {showUppertitle(dat.main?.uppertitle)}
                                                    {dat.main?.title?.home}
                                                </h2>
                                            </div>
                                            <a href={dat.info?.link?.url} className="cover-link" title={dat.main?.title?.home}></a>
                                        </article>
                                    )
                                }else{
                                    return (
                                        <article className="medium-entry-box" key={index}>
                                            <div className="entry-data">
                                                <h2 className="entry-title">
                                                    {showUppertitle(dat.main?.uppertitle)}
                                                    {dat.main?.title?.home}
                                                </h2>
                                            </div>
                                            <a href={dat.info?.link?.url} className="cover-link" title={dat.main?.title?.home}></a>
                                        </article>
                                    )}
                            })
                        }
                </div>
                {/*<!-- 3 entrys fijos end -->*/}

            
                <NewsVertical03/>
                {/*<!-- Comentarios -->*/}
                {slug === 'cosa-de-locos' && (
                <section className='nota-comments has-sm-mobile-gutter'>
                    <div id='fbkCommentsLink'></div>
                    <p className='uppercase'>Dejanos tu comentario</p>
                    <div
                    className='fb-comments'
                    data-lazy='true'
                    data-href={`https://www.cronica.com.ar${dataFace?.info?.link?.url}`}
                    data-width='100%'
                    data-numposts='5'
                    ></div>
                </section>
                )}
                {/*<!-- Comentarios end -->*/}
              
            </section>
            </>
                :null
            }
        </>
    )
}

export default ZonaNews4Notas;